<template>
	<div class="store-basic-info">
		<div class="fx-header">
			<p>店铺设置</p>
		</div>
		<search @handleSearch="handleSearch"/>
		<div class="features-btn-box">
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="add" v-if="AuthorityList['01_0001_0002_00'] && newbaseinfo === 0">新建</el-button>
			<!-- <el-button type="primary" size='small' class="fx-big-btn" plain @click="deleteStore" v-if="AuthorityList['01_0001_0003_00']">删除</el-button> -->
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="storeStatusChange(0)" v-if="AuthorityList['01_0001_0004_00']">启用</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="storeStatusChange(1)" v-if="AuthorityList['01_0001_0005_00']">停用</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" plain @click="settingMulti">批量设置</el-button>
			<el-button v-if='clddock === 1 && AuthorityList["01_0001_0009_00"]' type="primary" size='small' class="fx-big-btn" plain @click="pull">拉取</el-button>
			<!-- <el-button type="primary" plain v-if="AuthorityList['01_0001_0006_00']">导入</el-button>
			<a href="" class="download-btn">
				<i class="download-icon"/>
				<span>模板下载</span>
			</a> -->
		</div>
		<div class="table-div">
			<main-table
				:tableData='tableData'
				:totalCount='totalCount'
				:deleteAuthority='AuthorityList["01_0001_0003_00"]'
				:viewAuthority='AuthorityList["01_0001_0001_00"] || AuthorityList["01_0001_0008_00"]'
				@handleSize='handleSizeChange'
				@handlePage='handlePageChange'
				@saveShop='saveShop'
				@handleSelection='handleSelectionChange'
				@handleDelete='handleDelete'
			/>
		</div>
		<el-dialog title="批量设置" class="confirm-dialog" top='60px' :visible.sync="multiSetModel" width='600px' :close-on-click-modal="false">
			<div class="dialog-container">
				<div class="input-box">
					<span style="margin-right:20px;">将字段</span>
					<el-select v-model="lineSelect" class="input-span" size='mini'>
						<el-option label="小程序信息" value="0"></el-option>
						<el-option label="营业时间" value="1"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<div class="change-title">修改为</div>
					<div class="change-right" v-show="lineSelect === '0'">
						<div>
							<el-form label-width="130px" :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" class="form-box">
								<el-form-item label="AppID：" prop="appid">
									<el-input v-model="ruleForm.appid" size='mini' class="short-input" placeholder="请输入AppID"></el-input>
								</el-form-item>
								<el-form-item label="小程序名称：" prop="miniName">
									<el-input v-model="ruleForm.miniName" size='mini' class="short-input" placeholder="请输入小程序名称" maxlength="50" @input="checkSize"></el-input>
								</el-form-item>
								<div style="color: red;margin-left: 130px;">请务必填写正确的小程序名称</div>
							</el-form>
						</div>
					</div>
					<div class="change-right" v-show="lineSelect === '1'">
						<div class="close-shoptime-container">
							<div class="setting-change">
								<div>
									<div class="label">是否启用营业：</div>
									<el-switch v-model="closeShopflag" size="small" class="set-flag-switch" :active-value="false" :inactive-value="true" active-text="开" inactive-text="关" :active-color="$fxPrimaryColor" inactive-color="#dcdfe6"/>
								</div>
								<div class="tips">
									<span v-show="closeShopflag">关闭时，用户可在任意时间下单。</span>
									<span v-show="!closeShopflag">开启后，营业时间内用户可以下单。</span>
								</div>
							</div>
						</div>
						<div class="setting-detail" v-if="!closeShopflag">
							<div class='row-box'>
								<div class="label">非营业日期：</div>
								<el-date-picker
									size="mini"
									format='yyyy-MM-dd'
									value-format='yyyy-MM-dd'
									type="dates"
									v-model="unOpenDate"
									placeholder="选择一个或多个日期">
								</el-date-picker>
								<div class="tips">
									<span>设置非营业日期后，非营业日期不允许用户下单，未设置非营业日期时，默认当前店铺按所有正常营业日期范围营业</span>
								</div>
							</div>
							<div class="detail-box">
								<div class="label">营业时间段：</div>
								<div class="all-time-box">
									<div v-for="(item, index) in timeList" :key="index" class="time-item">
										<el-time-select
											v-model="item.startDate"
											class="date-box"
											format="HH:mm"
											value-format="HH:mm"
											size="mini"
											:picker-options="{
												selectableRange: `00:00:00 -${item.endDate ? item.endDate + ':00' : '24:00:00'}`,
												step: '00:15',
												start: '00:00',
												end: !item.endDate ? '24:00' : item.endDate
											}"
											placeholder="请选择"
											@change="changeStartTime(item, index)"
										></el-time-select> ~
										<el-time-select
											v-model="item.endDate"
											class="date-box"
											format="HH:mm"
											value-format="HH:mm"
											size="mini"
											:picker-options="{
												selectableRange: `${item.startDate ? item.startDate + ':00' : '00:00:00'}-24:00:00`,
												step: '00:15',
												start: item.startDate,
												end: '24:00'
											}"
											placeholder="请选择"
											@change="changeEndTime(item, index)"
										></el-time-select>
										<i class="el-icon-remove-outline delete" v-if="item.isShow" @click="deleteItem(item, index)"></i> <span style="color:#F56C6C;margin-left: 20px;" v-if="item.errorFlag || item.errorFlag2">时间段不能交叉</span>
									</div>
								</div>
							</div>
							<div class="add" @click="addItem">+ 添加</div>
						</div>
					</div>
				</div>
				<div class="btn-box" style="margin-top:30px;">
					<el-button size="small" class="btn" plain type="primary" @click="cancelMulti">取消</el-button>
					<el-button size="small" class="btn" plain type="primary" @click="confirmMulti">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="confirm-dialog" @close="cancel" top='60px' :visible.sync="confirmVisible" width='600px' :close-on-click-modal="false">
			<div class="confirm-dialog-container">
				<span style="margin-bottom:10px">以下店铺与云供应链的品项状态不一致，是否修改成为列表中的状态？</span>
				<div class="main-table">
					<div class="main-table-box">
						<el-table
							size='mini'
							:data="shopTableData"
							ref="multipleTable"
							border
							stripe
							:height="tableHeight"
							@selection-change="selectionChangeHandle"
						>
							<el-table-column
								type="selection"
								align="center"
								width="55">
							</el-table-column>
							<el-table-column
								prop="name"
								label="店铺名称"
								align="center"
								min-width="180">
							</el-table-column>
							<el-table-column
								prop="enableFlag"
								label="在供应链中状态"
								align="center"
								min-width="180">
								<template slot-scope="scope">
									<span v-if='scope.row.enableFlag === 1'  style="color:green">启用</span>
									<span v-if='scope.row.enableFlag === 0'  style="color:red">停用</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="btn-box">
					<el-button size="small" class="btn" plain type="primary" @click="cancel">否</el-button>
					<el-button size="small" class="btn" plain type="primary" @click="confirm">是</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog top='60px' class="pull-dialog" :visible.sync="dialogVisible" width='800px' :close-on-click-modal="false">
			<PullDialog :pullData='pullData'  @tableReload='tableReload' v-if='dialogVisible' :visible.sync="dialogVisible"/>
		</el-dialog>
	</div>
</template>

<script>
import PullDialog from '@/components/storeSetting/PullDialog.vue'
import Search from '@/components/storeSetting/Search.vue'
import MainTable from '@/components/storeSetting/MainTable.vue'
export default {
	name: 'storeBasicInfo',
	components: {
		Search,
		MainTable,
		PullDialog
	},
	data () {
		return {
			clddock: null,
			newbaseinfo: null,
			cldPullFlag: null,
			dialogVisible: false,
			confirmVisible: false,
			shopTableData: [],
			pullData: [],
			tableHeight: '100%',
			AuthorityList: {
				'01_0001_0001_00': false,
				'01_0001_0002_00': false,
				'01_0001_0003_00': false,
				'01_0001_0004_00': false,
				'01_0001_0005_00': false,
				'01_0001_0006_00': false,
				'01_0001_0008_00': false
			},
			shopname: '',
			stopflag: '-1',
			shopstate: '-1',
			applystatue: '-1',
			sourceflag: '-1',
			dbName: '',
			page: '1',
			size: '20',
			tableData: [],
			totalCount: 0,
			shopids: [],
			multiSetModel: false,
			lineSelect: '1',
			ruleForm: {
				appid: '',
				miniName: ''
			},
			rules: {
				appid: [
					{ required: true, message: '请输入AppID', trigger: 'blur' }
				],
				miniName: [
					{ required: true, message: ' ', trigger: 'blur' }
				]
			},
			unOpenDate: [],
			shopId: '',
			timeList: [
				{
					startDate: '',
					endDate: '',
					isShow: false,	// 隐藏删除时间段按钮标记
					errorFlag: false,	// true:stardate交叉, false:stardate不交叉
					errorFlag2: false	// true:endDate发生交叉，false:endDate不交叉
				}
			],
			copyTimeList: [],
			closeShopflag: true,	// 是否启用营业时间标记 false:开启 true:关闭
			newArr: []	// 存放转换为Number的时间段
		}
	},
	created () {
		let a = window.sessionStorage.getItem('shopInfo')
		if (a) {

		} else {
			this.listPost()
		}
		this.getAuthority('01_0001_0000_00')
	},
	methods: {
		saveShop () {
			let info = {
				shopname: this.shopname,
				stopflag: this.stopflag,
				shopstate: this.shopstate,
				applystatue: this.applystatue,
				sourceflag: this.sourceflag }
			let a = JSON.stringify(info)
			window.sessionStorage.setItem('shopInfo', a)
		},
		tableReload (data) {
			if (data === true) {
				this.listPost()
			}
		},
		selectionChangeHandle (data) {
			this.selectedArr = data
		},
		settingMulti () {
			if (this.shopids.length < 1) {
				this.$message.error('请至少选择一个店铺！')
				return false
			}
			this.multiSetModel = true
		},
		cancelMulti () {
			this.multiSetModel = false
		},
		confirmMulti () {
			switch (this.lineSelect) {
			case '0':
				this.saveAppid()
				break
			case '1':
				this.saveOpenTime()
				break
			}
		},
		saveAppid () {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let data = {
						shopIds: this.shopids,
						wechatAppid: this.ruleForm.appid,
						wechatAppname: this.ruleForm.miniName
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/updateWechatAppid`,
						data: data
					}).then(res => {
						if (res.result) {
							this.multiSetModel = false
							this.$message.success(res.msg)
							this.listPost()
						} else {
							this.$message.error(res.msg)
						}
					})
				} else {
					return false
				}
			})
		},
		saveOpenTime () {
			// console.log(this.timeList)
			let len = this.timeList.length
			for (let i = 0; i < len; i++) {
				if (((!this.timeList[i].startDate && this.timeList[i].endDate) || (this.timeList[i].startDate && !this.timeList[i].endDate)) && len === 1) {
					this.$message.error('时间段不能为空！')
					return false
				}
				if ((!this.timeList[i].startDate || !this.timeList[i].endDate) && len > 1) {
					this.$message.error('时间段不能为空！')
					return false
				}
				if (this.timeList[i].errorFlag || this.timeList[i].errorFlag2) {
					this.$message.error('时间段不能交叉！')
					return false
				}
				if ((this.timeList[i].startDate && this.timeList[i].endDate) && (this.timeList[i].startDate === this.timeList[i].endDate)) {
					this.$message.error('请选择正确时间段！')
					return false
				}
			}
			let unOpenDate = ''
			if (this.unOpenDate && this.unOpenDate.length > 0) {
				unOpenDate = this.unOpenDate.join(',')
			}
			let timeList = this.timeList
			if (timeList.length === 1 && (!timeList[0].startDate && !timeList[0].endDate)) {
				if (!this.closeShopflag && (!this.unOpenDate || this.unOpenDate.length === 0)) {
					this.$message.error('请填写信息！')
					return false
				}
				timeList = null
			}
			let params = {
				unOpenDate: unOpenDate,
				shopIds: this.shopids,
				dateList: timeList,
				type: this.closeShopflag ? 0 : 1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveShopOpenDateBatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.multiSetModel = false
					this.listPost()
					this.$message.success('保存成功！')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		checkSize () {
			if (this.ruleForm.miniName.length > 50) {
				this.$message.error('请输入50个字以内的小程序名称！')
				return false
			}
		},
		confirm () {
			if (this.selectedArr.length < 1) {
				this.$message.error('请至少选择一个店铺！')
			} else {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/dockcld/synchronizeShopStopFlag`,
					data: this.selectedArr
				}).then(res => {
					if (res.result === true) {
						this.confirmVisible = false
						this.dialogVisible = true
						this.listPost()
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		cancel () {
			this.confirmVisible = false
			this.dialogVisible = true
		},
		pull () {
			let params = {}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/match/getWDTShopInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.pullData = res.data
					this.dialogVisible = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		listPost () {
			let params = {
				shopname: this.shopname,
				stopflag: +this.stopflag,
				shopstate: +this.shopstate,
				applystatue: +this.applystatue,
				sourceflag: +this.sourceflag,
				page: this.page,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/list`,
				data: params
			}).then(res => {
				this.newbaseinfo = res.newbaseinfo
				this.clddock = res.clddock
				this.tableData = res.recordList
				this.totalCount = res.recordCount
			})
		},
		handleSearch (value) {
			this.shopname = value.shopname
			this.stopflag = value.stopflag
			this.shopstate = value.shopstate
			this.applystatue = value.applystatue
			this.sourceflag = value.sourceflag
			this.page = 1
			this.size = 20
			this.listPost()
		},
		handleSizeChange (value) {
			this.size = value.size
			this.listPost()
		},
		handlePageChange (value) {
			this.page = value.page
			this.listPost()
		},
		handleSelectionChange (value) {
			this.shopids = value.map(item => {
				return item.id
			})
		},
		storeStatusChange (flag) {
			if (this.shopids.length < 1) {
				this.$message.warning('请至少勾选一个店铺！')
				return false
			}
			let params = {
				shopids: this.shopids,
				stopflag: flag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/stopFlag`,
				data: params
			}).then(res => {
				if (res.resultFlag) {
					this.$message.success(res.message)
					this.listPost()
				} else {
					this.$message.error(res.message)
				}
			})
		},
		add () {
			sessionStorage.removeItem('storeid')
			window.sessionStorage.setItem('isAdd', true)
			this.$router.push('storeSetting')
		},
		deletePost (params) {
			this.$confirm('是否确认删除店铺？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/delete`,
					data: params
				}).then(res => {
					if (res.resultFlag) {
						this.$message.success(res.message)
						this.listPost()
					} else {
						this.$message.error(res.message)
					}
				})
			})
		},
		handleDelete (data) {
			let params = {
				shopids: [data]
			}
			this.deletePost(params)
		},
		deleteStore () {
			if (this.shopids.length < 1) {
				this.$message.warning('请至少勾选一个店铺！')
				return false
			}
			let params = {
				shopids: this.shopids
			}
			this.deletePost(params)
		},
		// 时间转换数字
		date2Number (date1, date2) {
			return date1 && date2 ? [+date1.split(':').join(''), +date2.split(':').join('')] : +date1.split(':').join('')
		},
		// 修改开始时间
		changeStartTime (e, i) {
			if (e.startDate) {
				let date = this.date2Number(e.startDate)
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startDate && item.endDate && i !== index) {
						this.newArr.push(this.date2Number(item.startDate, item.endDate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if ((date > item[0] || date === item[0]) && date < item[1]) {
							e.errorFlag = true
						} else {
							e.errorFlag = false
						}
						_BooleanArr.push(e.errorFlag)
					})
					e.errorFlag = _BooleanArr.some(item => { return item === true })
					// console.log(e)
				}
			} else {
				e.errorFlag = false
			}
		},
		// 修改结束时间
		changeEndTime (e, i) {
			if (e.endDate) {
				let date = this.date2Number(e.endDate)
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startDate && item.endDate && i !== index) {
						this.newArr.push(this.date2Number(item.startDate, item.endDate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if (date > item[0] && (date < item[1] || date === item[1])) {
							e.errorFlag2 = true
						} else {
							e.errorFlag2 = false
						}
						_BooleanArr.push(e.errorFlag2)
					})
					e.errorFlag2 = _BooleanArr.some(item => { return item === true })
				}
			} else {
				e.errorFlag2 = false
			}
		},
		// 添加时间段
		addItem (e) {
			let item = {
				startDate: '',
				endDate: '',
				isShow: true,
				errorFlag: false,
				errorFlag2: false
			}
			this.timeList.push(item)
			this.timeList[0].isShow = true
		},
		// 删除时间段
		deleteItem (item, index) {
			this.timeList.splice(index, 1)
			let len = this.timeList.length
			if (len === 1) {
				this.timeList[0].isShow = false
				this.timeList[0].errorFlag = false
				this.timeList[0].errorFlag2 = false
			} else {
				this.timeList.forEach((e, i) => {
					if (e.errorFlag || e.errorFlag2) {
						this.changeStartTime(e, i)
						this.changeEndTime(e, i)
					}
				})
			}
		},
		formatDate (arr) {
			let foundIndex = arr.findIndex(item => item === '24:00')
			arr[foundIndex] = '23:59'
			return arr
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-basic-info {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.features-btn-box {
		text-align left
		padding 20px 0
		box-sizing border-box
		border-top: 1px solid #dce2fd
		.download-btn {
			display inline-block
			height 20px
			margin-left 20px
			.download-icon {
				display inline-block
				width 20px
				height 20px
				background-image: url('~images/icon/download.png')
				vertical-align top
			}
			span {
				display inline-block
				height 20px
				line-height 20px
			}
		}
	}
	.table-div{
		flex:1
	}
	.form-box {
		display flex
		flex-direction column
		text-align left
		.short-input {
			width: 250px
		}
	}
}
</style>
<style lang="stylus">
.store-basic-info {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
		padding-bottom :20px
	}
	.el-dialog__headerbtn{
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 20px;
		font-weight:blod;
		.el-icon-close{
			color:#fff
		}
	}
	.dialog-title {
		text-align: left
	}
	.pull-dialog {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px
			border: none
		}
	}
	.confirm-dialog {
		text-align left
		.el-dialog {
			.btn-box {
				margin-top 15px;
				display flex
				justify-content center
				.btn {
					width: 120px;
				}
			}
		}
		.dialog-container {
			display: flex
			flex-flow: column
			.item {
				display: flex;
				align-items: center;
				line-height: 70px;
				img {
					padding-right: 31px
				}
				span {
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
				.search-btn {
					position: absolute;
					right: 20px;
					font-size: 12px;
					text-decoration: underline;
					color: var(--fx-primary-color);
					cursor: pointer;
				}
			}
			.input-box{
				display: flex
				align-items: center
				margin-bottom:20px;
				.input-span{
					width:180px;
					margin-left:10px
				}
				.change-title {
					margin-right: 30px;
					display: inline-block;
					min-width: 42px;
					vertical-align: top;
				}
				.change-right {
					margin-top: 3px;
					display: inline-block;
					.row-box{
						text-align: left
						.label {
							display: inline-block
							width: 100px
							text-align: right
						}
					}
					.tips {
						padding: 10px 100px
						color: #999
					}
					.close-shoptime-container {
						display flex
						.setting-change {
							display: flex
							flex-flow: column
							justify-content: start
							align-items: start
							.label {
								display: inline-block
								width: 100px
								text-align: right
							}
							.tips {
								padding: 10px 100px
								color: #999
							}
						}
					}
					.setting-detail {
						display: flex
						align-items: flex-start
						overflow: hidden
						flex-flow: column
						flex:1
						.detail-box {
							display: flex
							flex-flow: row
							align-items: baseline
							overflow-y: auto;
							padding-right: 45px;
							.label {
								display: inline-block
								width: 100px
								text-align: right
							}
							.all-time-box {
								display: flex;
								flex-flow: column;
								align-items: start;
								.time-item {
									padding: 10px 0
								}
							}
							.el-date-editor.el-input, .el-date-editor.el-input__inner {
								width: 130px
							}
							.delete {
								color: #999
								font-size: 14px
								margin-left: 15px
								cursor: pointer
							}
						}
						.add {
							width: 272px
							min-height: 23px
							border: 1px dashed #999
							margin: 10px 100px
							display: flex
							align-items: center
							justify-content: center
							cursor: pointer
							color: #999
						}
					}
					.set-flag-switch .el-switch__label {
						position: absolute;
						display: none;
						color: #fff;
					}
					.input-error .el-input__inner {
						border-color: #F56C6C
					}
					/*打开时文字位置设置*/
					.set-flag-switch .el-switch__label--right {
						z-index: 1
						right: -6px
					}
					/*关闭时文字位置设置*/
					.set-flag-switch .el-switch__label--left {
						z-index: 1
						left: 19px
					}
					/*显示文字*/
					.set-flag-switch .el-switch__label.is-active {
						display: block;
					}
					.set-flag-switch.el-switch .el-switch__core, .el-switch .el-switch__label {
						width: 40px !important;
					}
				}
			}
		}
		.confirm-dialog-container {
			height: 400px;
			.main-table {
				height: 300px;
				padding-bottom 10px;
				.main-table-box {
					height: 300px;
					margin-bottom 10px;
					// overflow-y: auto;
				}
			}
		}
	}
}
</style>
